import * as React from "react";

function SvgHeading3(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M7.7 12.6H6.2V8.4H2v4.2H.5V3.3H2v3.8h4.2V3.3h1.5v9.3zM15.2 5.5c0 .6-.2 1.1-.5 1.5-.3.4-.8.7-1.4.8v.1c.7.1 1.3.3 1.6.7.4.4.6.9.6 1.5 0 .9-.3 1.6-.9 2.1-.6.5-1.5.7-2.6.7-1 0-1.9-.2-2.5-.5v-1.3c.4.2.8.3 1.2.5.4.1.8.2 1.2.2.7 0 1.2-.1 1.6-.4.4-.3.5-.7.5-1.2s-.2-.9-.6-1.1-1-.3-1.8-.3h-.8V7.3h.8c1.4 0 2.2-.5 2.2-1.5 0-.4-.1-.7-.4-.9-.3-.2-.6-.3-1.1-.3-.4 0-.7 0-1 .1-.3.1-.7.3-1.1.6l-.7-1c.8-.6 1.8-.9 2.9-.9.9 0 1.6.2 2.1.6.4.2.7.8.7 1.5z" /></svg>;
}

export default SvgHeading3;